import { useState, useEffect } from 'react';
import { Box, useTheme } from '@mui/material';
import { tokens } from '../../theme';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Header from '../../Components/Headers/Header';
import SideBarPanel from '../../NavBars/SideBarPanel';
import TopBar from '../../NavBars/TopBar';
import styles from './ResponseList.module.css';
import getResponseListFromDB from './Utilities/getResponseListFromDB';
import getColumns from './Utilities/getColumnsResponseList';
import { supabase } from '../../Utilities/SupabaseClient';

// This component shows a table of all suppliers entered into the system
// by the user. The table has key information for each supplier in it.
const ResponseList = () => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const [responseListData, setResponseListData] = useState([]);
	const columns = getColumns(colors);
	const [loading, setLoading] = useState(true);
	const [rowCount, setRowCount] = useState(0);
	const [sortField, setSortField] = useState('created_at'); // Default sorting field
	const [sortDirection, setSortDirection] = useState('asc'); // Default sorting direction
  const [pageSize, setPageSize] = useState(25); // Default to 25 rows per page
	const [paginationModel, setPaginationModel] = useState({
		page: 0,
		pageSize: 25,
	});

	useEffect(() => {
		const { data: authListener } = supabase.auth.onAuthStateChange(
			(event, session) => {
				if (session) {
					supabase.auth.setSession(session);
				}
			}
		);

		return () => {
			authListener?.subscription.unsubscribe();
		};
	}, []);

	useEffect(() => {
		async function getData() {
			const session = await supabase.auth.getSession();
			if (!session.data.session) return;

			setLoading(true);

			const { cleanedData, count } = await getResponseListFromDB(
				session.data.session.user.id,
				paginationModel.page,
				pageSize,
				sortField,
				sortDirection
			);

			console.log('cleanedData:: ', cleanedData);

			const sortedCleanedData = cleanedData.sort(
				(a, b) => new Date(b.created_at) - new Date(a.created_at)
			);

			setResponseListData(sortedCleanedData);
			setRowCount(count);
			setLoading(false);

			console.log('count:: ', count);
		}

		getData();
		console.log('sortField, sortDirection: ', sortField, sortDirection);
		console.log('paginationModel: ', paginationModel);
	}, [paginationModel, pageSize, sortField, sortDirection]); // Re-fetch when page or pageSize changes

	return (
		<>
			<SideBarPanel />
			<main className={styles.responselistmain}>
				<nav>
					<TopBar />
				</nav>
				<Box m='20px'>
					<Header title='ASSESSMENT RESPONSES' subtitle='Responses Received' />
					<div className={styles.responselisttablewrapper}>
						<Box
							m='40px 0 0 0'
							height='75vh'
							sx={{
								'& .MuiDataGrid-root': {
									border: 'none',
								},
								'& .MuiDataGrid-cell': {
									borderBottom: 'none',
								},
								'& .name-column--cell': {
									color: colors.greenAccent[300],
								},
								'& .MuiDataGrid-columnHeaders': {
									backgroundColor: colors.blueAccent[700],
									borderBottom: 'none',
								},
								'& .MuiDataGrid-virtualScroller': {
									backgroundColor: colors.primary[400],
								},
								'& .MuiDataGrid-footerContainer': {
									borderTop: 'none',
									backgroundColor: colors.blueAccent[700],
								},
								'& .MuiCheckbox-root': {
									color: `${colors.greenAccent[200]} !important`,
								},
								'& .MuiDataGrid-toolbarContainer .MuiButton-text': {
									color: `${colors.grey[100]} !important`,
								},
							}}
						>
							<Box sx={{ height: 550, width: '100%' }}>
								<DataGrid
									components={{ Toolbar: GridToolbar }}
									rows={responseListData}
									rowCount={rowCount}
									columns={columns}
									loading={loading}
									pageSizeOptions={[25, 50, 100]}
									paginationModel={{ page: paginationModel.page, pageSize }} // Use pageSize here directly
									paginationMode='server'
									sortingMode='server'
									onPageChange={(newPage) => {
										setPaginationModel((prevModel) => ({
											...prevModel,
											page: newPage,
										}));
									}}
									onPageSizeChange={(newPageSize) => {
										setPageSize(newPageSize); // Update pageSize state
										setPaginationModel((prevModel) => ({
											...prevModel,
											pageSize: newPageSize,
											page: 0,
										}));
									}}
									onSortModelChange={(sortModel) => {
										if (sortModel.length > 0) {
											setSortField(sortModel[0].field);
											setSortDirection(sortModel[0].sort);
											setPaginationModel((prevModel) => ({
												...prevModel,
												page: 0, // Reset to the first page on sort change
											}));
										}
									}}
									initialState={{
										pagination: {
											paginationModel: { pageSize: 25, page: 0 },
										},
									}}
									sx={{
										fontSize: '14px',
									}}
								/>
							</Box>
						</Box>
					</div>
				</Box>
			</main>
		</>
	);
};

export default ResponseList;
